import BaseService from '../base.service'
const endpoint = 'api/chat'
export class DirectMessagingBEService extends BaseService {
  constructor(parameters = {}) {
    super(endpoint, parameters)
  }
  history(device_id) {
    return this.submit('get', `${endpoint}/history/${device_id}`)
  }
  join(device_id) {
    return this.submit('post', `${endpoint}/join/${device_id}`)
  }
  send(device_id, data) {
    return this.submit('post', `${endpoint}/send/${device_id}`, data)
  }
  group(data) {
    return this.submit('get', `${endpoint}/group`, data)
  }
}